import { Fragment } from 'react';

import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ athlete, onCheckboxChange, onYesNoSwitchChange, allowRelayOnly }) => {
  return (
    <tr key={athlete.orgUnitAthleteEntryId}>
      <td>{(athlete.firstName || athlete.middleName || athlete.lastName) ? `${athlete.firstName || ''}  ${athlete.preferredName !== '' && athlete.preferredName !== athlete.firstName ? '"' + athlete.preferredName + '"' : ''} ${athlete.middleName || ''} ${athlete.lastName || ''}` : ''}</td>
      <td>{athlete.competitionGenderTypeName || ''}</td>
      <td>{athlete.birthDate ? formatDate(athlete.birthDate) : ''}</td>
      <td>{athlete.ageAtMeet >= 0 && athlete.ageAtMeet !== null ? athlete.ageAtMeet : ''}</td>
      <td>
        {athlete.addedAsUnattached === false ?
          <Fragment>
            {(athlete.canBeDeleted === true || (athlete.isRelayAthlete === false && athlete.hasPaid === false)) ?
              <Checkbox
                label=""
                name="isSelected"
                onChange={(e) => { onCheckboxChange(e, athlete.personId) }}
                checked={athlete.isSelected} /> :
              <Checkbox
                label=""
                name="isSelected"
                onChange={(e) => { onCheckboxChange(e, athlete.personId) }}
                checked={athlete.isSelected}
                disabled={true} />
            }
          </Fragment>
          :
          <div>Entered Meet as Unattached</div>}
      </td>
      {allowRelayOnly === true &&
        <td>
          {athlete.addedAsUnattached === false &&
            <Fragment>
              {athlete.isSelected === true &&
                <Fragment>
                  {athlete.isIndividualAthlete === true ?
                    <YesNoSwitch
                      label=""
                      name={'isRelayOnlyAthlete' + athlete.personId}
                      onChange={(e) => { onYesNoSwitchChange(e, athlete.personId) }}
                      checked={athlete.isRelayOnlyAthlete}
                      disabled={true} /> :
                    <YesNoSwitch
                      label=""
                      name={'isRelayOnlyAthlete' + athlete.personId}
                      onChange={(e) => { onYesNoSwitchChange(e, athlete.personId) }}
                      checked={athlete.isRelayOnlyAthlete} />}
                </Fragment>}
            </Fragment>}
        </td>}
    </tr>
  );
};

const OrgUnitAdminRosterSelectionLargeGrid = ({ gridData, isLoading, onCheckboxChange, onYesNoSwitchChange, allowRelayOnly }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Name</th>
        <th style={{ minWidth: '125px' }}>Comp. Category</th>
        <th>Birth Date</th>
        <th style={{ minWidth: '90px' }}>Age at Meet</th>
        <th>Select</th>
        {allowRelayOnly === true &&
          <th style={{ minWidth: '160px' }}>Relay Only Swimmer?</th>}
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan={allowRelayOnly === true ? "6" : "5"}>Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0 ?
          gridData.map((athlete, i) =>
            <GridRow
              key={i}
              athlete={athlete}
              onCheckboxChange={onCheckboxChange}
              onYesNoSwitchChange={onYesNoSwitchChange}
              allowRelayOnly={allowRelayOnly} />)
          :
          <tr>
            <td colSpan={allowRelayOnly === true ? "6" : "5"}>No Results</td>
          </tr>
      }
    </tbody>
  </table>
);

export default OrgUnitAdminRosterSelectionLargeGrid;